import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import type { PaginatedResponse, PaginationParams } from "@/api/types";
import { api } from "@/lib/api";
import type { MeterKey } from "./types";

export type MeterKeyParams = PaginationParams & {
	district?: number | null;
	search?: string;
	ordering?: string;
};

export function useMeterKeys(
	params?: MeterKeyParams,
): UseQueryResult<PaginatedResponse<MeterKey>, Error> {
	return useQuery({
		queryKey: queryKeys.districts.meterKeys(params ?? {}),
		queryFn: async (): Promise<PaginatedResponse<MeterKey>> => {
			const res = await api.get<PaginatedResponse<MeterKey>>(
				"/api/districts/meter_keys/",
				{ params },
			);
			return res.data;
		},
	});
}
